import { useQuery } from '@tanstack/react-query';
import { useEffect, useMemo, useState } from 'react';
import { debounce } from 'lodash';
import { ExtendedDbCloudWalletUserInfo } from '@shared/types/db/user';
const _getUsernames = async (phrase: string, address?: string) => {
  const _url = `/api/db/searchUsername?username=${phrase}&address=${address}`;
  try {
    const _res = await fetch(_url, {
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    const _json = await _res.json();
    return _json;
  } catch (error) {
    console.log('_getUsernames:error', {
      error
    });
    throw new Error('error _getUsernames');
  }
};
export const useGetUsernames = ({
  phrase,
  address
}: {
  phrase?: string;
  address?: string;
}) => {
  const [debouncedPhrase, setDebouncedPhrase] = useState('');

  // Debounce the input phrase update
  const debouncedSetPhrase = useMemo(() => debounce((value: string) => setDebouncedPhrase(value), 1000), []);

  // Update debounced value when phrase changes
  useEffect(() => {
    if (phrase) {
      debouncedSetPhrase(phrase);
    }
    return () => {
      debouncedSetPhrase.cancel();
    };
  }, [phrase, debouncedSetPhrase]);

  // Now use debouncedPhrase in the query
  const query = useQuery({
    queryKey: ['getUsernames', debouncedPhrase, address],
    staleTime: 10 * 60 * 1000,
    // 10 minutes
    queryFn: async (): Promise<ExtendedDbCloudWalletUserInfo[] | {
      error?: string;
    }> => {
      const results = await _getUsernames(debouncedPhrase, address);
      console.log('getUsernames', {
        debouncedPhrase,
        results
      });
      return results;
    },
    enabled: Boolean(debouncedPhrase.length > 0 && debouncedPhrase.length < 20 || address)
  });
  return query;
};